// Same-origin fetch wrapper that attaches the active project id so the
// backend can scope work to the opened project. Reads the id written by
// ActiveProjectContext. Falls back to no header (server uses the default).
const ACTIVE_PROJECT_KEY = 'active_project_id'

export function getActiveProjectId(): string | null {
  if (typeof window === 'undefined') return null
  try {
    return localStorage.getItem(ACTIVE_PROJECT_KEY)
  } catch {
    return null
  }
}

export function setActiveProjectId(projectId: string): void {
  try {
    localStorage.setItem(ACTIVE_PROJECT_KEY, projectId)
  } catch {
    /* ignore */
  }
}

export async function apiFetch(input: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers || {})
  const pid = getActiveProjectId()
  if (pid && !headers.has('X-Project-Id')) {
    headers.set('X-Project-Id', pid)
  }
  return fetch(input, { ...init, credentials: 'same-origin', headers })
}
